import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { throttle } from "@obg/global";
import { CoreConfig, DocumentMetaSelector, SeoContent } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { DeviceConfigService } from "@obg/ngx.global";
import { values } from "lodash-es";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
	selector: "obg-page-seo-content-container",
	templateUrl: "./page-seo-content.container.html",
	styleUrls: ["./page-seo-content.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class PageSeoContentContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-page-seo-content") hostCssClass = true;
	@HostBinding("attr.test-id") testId = "seosection";
	contentWrapper: ElementRef | undefined;
	@ViewChild("contentWrapper") set setContentWrapper(ref: ElementRef) {
		if (!ref) {
			return;
		}
		this.contentWrapper = ref;
		this.reset();
		this.setup();
	}

	isDesktop: boolean | undefined;
	seoContent: SeoContent | undefined;
	isContentCollapsed = true;
	isTransitionDisabled = true;
	hasOverflow = false;
	isBot = false;

	private width: number | undefined;
	private data$$: Subscription | undefined;

	constructor(
		private store: Store<CoreContentState>,
		private changeDetector: ChangeDetectorRef,
		private config: CoreConfig,
		private deviceConfigService: DeviceConfigService
	) {
		this.isBot = !!this.config.isBot;
	}

	ngOnInit() {
		this.data$$ = this.store
			.select(DocumentMetaSelector.getSeoContent)
			.pipe(
				tap((seoContent) => {
					this.seoContent = values(seoContent).filter((value) => !!value).length > 0 ? seoContent : undefined;
				})
			)
			.subscribe(() => this.changeDetector.markForCheck());

		this.isDesktop = this.deviceConfigService.isDesktop();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}

	@throttle(500)
	onResize() {
		const element = this.contentWrapper?.nativeElement;
		if (!element || (this.width && element?.offsetWidth === this.width)) {
			return;
		}
		this.setup();
	}

	toggleCollapseContent() {
		if (this.isTransitionDisabled) {
			this.isTransitionDisabled = false;
		}
		this.isContentCollapsed = !this.isContentCollapsed;
		this.changeDetector.markForCheck();
	}

	private reset() {
		this.isContentCollapsed = true;
		this.hasOverflow = false;
		this.isTransitionDisabled = true;
	}

	private setup() {
		const element = this.contentWrapper?.nativeElement;
		if (!element) {
			return;
		}

		const { offsetWidth, scrollHeight, offsetHeight } = element;
		this.width = offsetWidth;
		this.hasOverflow = scrollHeight !== undefined && offsetHeight !== undefined && scrollHeight > offsetHeight;
		this.changeDetector.markForCheck();
	}
}
